import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const WiseIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/Wise.jpeg" style={style} />
}
